import React from "react";


import { Col, Row } from "react-bootstrap";


import SectionContainerComponent from "@Components/Sections/SectionContainer";


import securityIcon from "@Icons/SVG/icon-security-m-orange.svg";
import visibilityOffIcon from "@Icons/SVG/icon-visibility_off-m-orange.svg";
import checkIcon from "@Icons/SVG/icon-check-m-orange.svg";
import searchIcon from "@Icons/SVG/icon-search-l-orange.svg";


import "./index.scss";
import SecurityPillarsCardComponent from "@Pages/Security/PillarsSection/CardElement";


const DATA = [
    {
        orderNr: 1,
        elementTitle: 'End-to-End Encryption',
        elementSubTitle: 'Data in transit & at rest encrypted with TLS 1.3 + AES-256',
        elementDescription: 'Your emails and personal data are protected with military-grade encryption at every step. Whether data is moving between servers or stored in our databases, it\'s always encrypted.',
        elementIcon: securityIcon,
        elementInfo: 'TLS 1.3 in Transit\n AES-256 at Rest',
    },
    {
        orderNr: 2,
        elementTitle: 'Read-Only by Default',
        elementSubTitle: 'C.A.R.E. never sends mail unless you explicitly enable our Send As option',
        elementDescription: 'We can only read your emails to find refund opportunities. We cannot send, delete, or modify your emails without your explicit permission for specific claim filing.',
        elementIcon: visibilityOffIcon,
        elementInfo: 'Read-Only by Default\n Optional Send As for Claims',
    },
    {
        orderNr: 3,
        elementTitle: 'SOC-2 Type I Underway',
        elementSubTitle: 'Independent auditors monitor controls; Type II target Q2 2026',
        elementDescription: 'We\'re currently undergoing SOC-2 Type I certification with independent auditors reviewing our security controls and practices. Full Type II certification targeted for Q2 2026.',
        elementIcon: checkIcon,
        elementInfo: 'Type I: In Progress\n Type II: Q2 2026',
    },
    {
        orderNr: 4,
        elementTitle: 'GDPR Compliant',
        elementSubTitle: 'EU data stays in EU data-centres; 30-day auto-purge of raw emails',
        elementDescription: 'Full compliance with European data protection regulations. EU user data never leaves EU servers, and raw email data is automatically purged after 30 days.',
        elementIcon: searchIcon,
        elementInfo: 'EU Data in EU Centers\n 30-Day Auto-Purge',
    },
];


export const SecurityPagePillarsSection:React.FC = () => {


    const SecurityPillarsList = DATA.map((item) => {
       return (
           <SecurityPillarsCardComponent
                key={`item-${item.orderNr}`}
                {...item}
           />
       );
    });


    return (
        <SectionContainerComponent
            id={'security-page__pillars-section'}
            sectionHeaderText={'Security & Compliance Pillars'}
            sectionDescriptionText={'What each security measure means for you'}
            sectionType={'main'}
        >

            <Col xs={12} className={'security-page__pillars-section__cards-list'}>
                <Row className={'security-page__pillars-section__cards-list__content'}>

                    {SecurityPillarsList}

                </Row>
            </Col>

        </SectionContainerComponent>
    );

};


export default SecurityPagePillarsSection;
